import React, { useEffect, useState } from "react";
import { Badge, Collapse, Form } from "react-bootstrap";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useParams } from "react-router-dom";
import { FaDatabase } from "react-icons/fa";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studyEventManagementServices } from "../../../APIServices/studyEventManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";

const ViewEventSchema = ({ handleAddNewTab }) => {
  const [openEvents, setOpenEvents] = useState("");
  const [openTimePointEvents, setOpenTimePointEvents] = useState("");
  const [siteName, setSiteName] = useState("");
  const [schemaId, setSchemaId] = useState("no");
  const [schemaName, setSchemaName] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventId, setEventId] = useState("");
  const [eventSchemaLoader, setEventSchemaLoader] = useState(false);
  const [eventLoader, setEventLoader] = useState(false);
  const [eventTimepointLoading, setEventTimepointLoading] = useState(false);
  const [siteEventSchema, setSiteEventSchema] = useState([]);
  const [siteEventList, setSiteEventList] = useState([]);
  const [siteEventTimePointList, setSiteEventTimePointList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();

  const getStudySiteEventSchema = async () => {
    setEventSchemaLoader(true)
    let data = await studySiteDataEntryServices.getStudySiteEventSchema(studyId)
    setEventSchemaLoader(false)
    setSiteEventSchema(data?.data || [])
  }
  const getStudySiteEventDataBasedonSchema = async (siteId, schemaId) => {
    setEventLoader(true)
    let data = await studySiteDataEntryServices.getStudySiteEventDataBasedonSchema(studyId, siteId, schemaId, "noSubject", StudyMode)
    setSiteEventList(data?.data || [])
    setEventLoader(false)
  }

  const getStudySiteEventTimePointDataBasedonEvent = async (siteId, schemaId, eventId) => {
    setEventTimepointLoading(true)
    let data = await studySiteDataEntryServices.getStudySiteEventTimePointDataBasedonEvent(studyId, siteId, schemaId, eventId, "noSubject", "no", "no", StudyMode)
    setSiteEventTimePointList(data?.data || [])
    setEventTimepointLoading(false)
  }

  const updateStatusStudyEventSchema = async (siteId, schemaId, type) => {
    let userData = {};
    userData.siteId = siteId;
    userData.schemaId = schemaId;
    userData.studyId = studyId;
    userData.type = type;
    let data = await studyEventManagementServices.updateStatusStudyEventSchema(userData);
    if (data?.statusCode === 200) {
      getStudySiteEventSchema();
      setSiteName("")
    }
  };

  useEffect(() => {
    getStudySiteEventSchema();
  }, []);
  return (
    <>
      {eventSchemaLoader ? (
        <div className="hstack justify-content-center" style={{ height: "calc(100vh - 145px)" }}>
          <PageLoader/>
        </div>
      ) : siteEventSchema?.length === 0 ? (
        <div className="hstack justify-content-center" style={{ height: "calc(100vh - 145px)" }}>
          <NoDataFoundTable MSG={"Event schema not found!"} />
        </div>
      ) : (
        <div className="d-flex gap-2 p-2 overflow-auto bg-light">
          {siteEventSchema?.map((site, index) => (
            <>
              <div key={index}>
                <div className="border br3 bg-white" style={{ width: 270 }}>
                  <div className="border-bottom p-2 hstack justify-content-between">
                    <Form.Label className="m-0 fw-bold">{site?.siteName}</Form.Label>
                  </div>
                  <div
                    className="overflow-auto"
                    style={{ height: "calc(100vh - 202px)" }}
                  >
                    {site?.eventSchemas?.map((schema, key) => (
                      <div key={key} className="hstack p-2 gap-3 justify-content-between border-bottom">
                        <div className="hstack gap-3">
                          <FaDatabase
                            className={schema?.status === "active" ? "text-success" : "text-danger"}
                            title={schema?.assignName}
                            style={{ width: 30, height: 30 }}
                          />
                          <div>
                            <Form.Label title={schema?.assignName} className="fw-bold m-0">
                              {schema?.schemaName}
                            </Form.Label>
                            <div>
                              <Badge
                                className={`br3 p-1 px-2 ${`${site?.siteId}${schema?.schemaId}` === openEvents ? "text-white" : "text-dark"} CP`}
                                bg={`${site?.siteId}${schema?.schemaId}` === openEvents ? (schema?.status === "active" ? "success" : "danger") : (schema?.status === "active" ? "success-subtle" : "danger-subtle")}
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  if (openEvents === `${site?.siteId}${schema?.schemaId}`) {
                                    setSchemaName("")
                                    setOpenEvents("")
                                    setSchemaId("")
                                    setOpenTimePointEvents("")
                                    setEventId("")
                                    setEventName("")
                                  } else {
                                    getStudySiteEventDataBasedonSchema(site?.siteId, schema?.schemaId);
                                    setSchemaName(schema?.schemaName)
                                    setSiteName(site?.siteName)
                                    setOpenEvents(`${site?.siteId}${schema?.schemaId}`)
                                    setSchemaId(schema?.schemaId)
                                  }
                                }}
                                title="View Events"
                              >
                                View Events
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="position-relative">
                          <Form.Check
                            type="switch"
                            className="mt-1"
                            checked={schema?.status === "active"}
                            onChange={() => updateStatusStudyEventSchema(schema?.siteId, schema?.schemaId, schema?.status === "active" ? "inactive" : "active")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <Collapse in={openEvents === `${site?.siteId}${schemaId}`} dimension="width">
                <div>
                  <div className="border br3 bg-white" style={{ minWidth: 200 }}>
                    <div className="border-bottom p-2">
                      <div className="hstack justify-content-between">
                        <Form.Label className="m-0 fw-bold">
                          {schemaName}
                        </Form.Label>
                        <IoIosCloseCircleOutline
                          className="text-danger CP"
                          title={`Close ${schemaName}`}
                          onClick={() => {
                            setSchemaName("")
                            setOpenEvents("")
                            setSchemaId("")
                            setOpenTimePointEvents("")
                            setEventId("")
                            setEventName("")
                          }}
                        />
                      </div>
                    </div>
                    <div className="overflow-auto px-2 pb-2" style={{ maxHeight: "calc(100vh - 202px)" }}>
                      {eventLoader ? (
                        <div
                          className="hstack justify-content-center"
                          style={{ height: "calc(100vh - 400px)" }}
                        >
                          <PageLoader/>
                        </div>
                      ) :
                        siteEventList?.map((event, i) => (
                          <div key={i}>
                            <Badge
                              bg={event?.eventId === eventId ? "primary" : "primary-subtle"}
                              style={{
                                fontSize: 10,
                                whiteSpace: "normal",
                                overflowWrap: "break-word",
                                textAlign: "left",
                                lineHeight: 1.5,
                              }}
                              className={`br3 p-1 px-2 w-100 ${event?.eventId === eventId ? "text-white" : "text-dark"} CP`}
                              title={`Time Point : ${event?.timePoint}`}
                              onClick={() => {
                                if (event?.timePoint === "Yes") {
                                  if (openTimePointEvents === `${site?.siteId}${event?.schemaId}${event?.eventId}`) {
                                    setOpenTimePointEvents("")
                                    setEventId("")
                                    setEventName("")
                                  } else {
                                    getStudySiteEventTimePointDataBasedonEvent(site?.siteId, event?.schemaId, event?.eventId)
                                    setEventName(event?.eventName)
                                    setEventId(event?.eventId)
                                    setOpenTimePointEvents(`${site?.siteId}${event?.schemaId}${event?.eventId}`)
                                  }
                                } else {
                                  handleAddNewTab(
                                    `${siteName}-${schemaName}-${event?.eventName}`, "",
                                    "viewEventSchemaFormLists",
                                    {
                                      siteId: site?.siteId,
                                      schemaId: event?.schemaId,
                                      type: "eventForm",
                                      viewType: "noEntry",
                                      eventId: event?.eventId,
                                    }
                                  );
                                }
                              }}
                            >
                              {event?.eventName}
                            </Badge>
                          </div>
                        ))}
                      {!eventLoader &&
                        <div>
                          <Badge
                            bg="primary-subtle"
                            style={{
                              fontSize: 10,
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                              textAlign: "left",
                              lineHeight: 1.5
                            }}
                            onClick={() => handleAddNewTab(
                              `${siteName}-${schemaName}-Special Event`, "",
                              "viewEventSchemaFormLists",
                              {
                                siteId: site?.siteId,
                                type: "specialForm",
                                schemaId: schemaId,
                              }
                            )}
                            className="br3 p-1 px-2 text-dark CP w-100"
                            title="View Special Event"
                          >
                            Special Event
                          </Badge>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </Collapse>
              <Collapse in={(openTimePointEvents === `${site?.siteId}${schemaId}${eventId}`) && openEvents === `${site?.siteId}${schemaId}`} dimension="width">
                <div>
                  <div className="border br3 bg-white" style={{ minWidth: 200 }}>
                    <div className="border-bottom p-2">
                      <div className="hstack justify-content-between">
                        <Form.Label className="m-0 fw-bold">
                          {eventName}
                        </Form.Label>
                        <IoIosCloseCircleOutline
                          className="text-danger CP"
                          title={`Close ${eventName}`}
                          onClick={() => { setOpenTimePointEvents(""); setEventId(""); setEventName("") }}
                        />
                      </div>
                    </div>
                    <div className="overflow-auto px-2 pb-2" style={{ maxHeight: "calc(100vh - 202px)" }}>
                      {eventTimepointLoading ? (
                        <div
                          className="hstack justify-content-center"
                          style={{ height: "calc(100vh - 400px)" }}
                        >
                          <PageLoader/>
                        </div>
                      ) :
                        siteEventTimePointList?.map((timePoint, inx) => (
                          <div key={inx}>
                            <Badge
                              bg="primary-subtle"
                              style={{
                                fontSize: 10,
                                whiteSpace: "normal",
                                overflowWrap: "break-word",
                                textAlign: "left",
                                lineHeight: 1.5
                              }}
                              onClick={() => handleAddNewTab(
                                `${siteName}-${schemaName}-${timePoint?.eventName} (${timePoint?.timePointLabel})`, "",
                                "viewEventSchemaFormLists",
                                {
                                  siteId: site?.siteId,
                                  schemaId: schemaId,
                                  eventId: timePoint?.eventId,
                                  type: "eventForm",
                                  viewType: "noEntry",
                                  timePointUniqueId: String(timePoint?.timePointUniqueId),
                                }
                              )}
                              className="br3 p-1 px-2 text-dark CP w-100"
                              title={timePoint?.timePointLabel}
                            >
                              {timePoint?.timePointLabel}
                            </Badge>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Collapse>
            </>
          ))}
        </div>
      )}
    </>
  );
};

export default ViewEventSchema;
